
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesPreview from './components/ServicesPreview';
import IndustriesSection from './components/IndustriesSection';
import CaseStudyHighlights from './components/CaseStudyHighlights';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesPreview />
        <IndustriesSection />
        <CaseStudyHighlights />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
